module.exports = __webpack_public_path__ + "img/NTS-F.76399941.png";